import {InputFileAcceptMimes, InputFileAcceptTypes} from "../../../../../core/constants/enums";
import React, {useState} from "react";
import DropZone from "../../../base/dropzone";

import ElementIds from "../../../../../core/models/element-ids";

const ChatDropZone = ({
                          disabled,
                          accept = [
                              InputFileAcceptMimes.images,
                              InputFileAcceptTypes.heic,
                              InputFileAcceptTypes.heif,
                              InputFileAcceptMimes.videos,
                              InputFileAcceptTypes.pdf,
                              InputFileAcceptTypes.zip,
                              InputFileAcceptTypes.rar,
                          ],
                          id = 'chat-drop-zone',
                          onFilesDrop,
                          multiple = true,
                          setTempUrl,
                          children,
                      }) => {
    const [loading, setLoading] = useState(false);


    return (
        <div id={ElementIds.chatSection} className={'w-100 h-100 chat-section'}>
            <DropZone
                disabled={disabled}
                identifier={'chat'}
                accept={accept}
                id={id}
                noParse={true}
                onSuccess={onFilesDrop}
                multiple={multiple}
                setTempUrl={setTempUrl}
                loading={loading}
                setLoading={setLoading}
                openOnClick={false}
                className={`row no-gutters align-items-center justify-content-center w-100 h-100`}
                dropZoneClassName={'w-100 h-100 p-0'}
                labelClassName={'w-100 h-100 p-0 m-0'}
            >
                {children}
            </DropZone>
        </div>
    );
}

export default ChatDropZone;
